export default __webpack_public_path__ + "static/media/viewer-web.3e6f2bf9.gif";